export default "__VITE_ASSET__mMVPAsLQ__"